import './page.css'
import Pagination from 'react-bootstrap/Pagination';

function Page({ totalDocs = 0, limit = 10, totalPages = 1, page = 1, onPageChange }) {
    
    if (totalPages <= 1) return null;

    const items = [];
    for (let number = 1; number <= totalPages; number++) {
        items.push(
            <Pagination.Item
                key={number}
                active={number === page}
                onClick={() => onPageChange && onPageChange(number)}
            >
                {number}
            </Pagination.Item>
        );
    }

    return (
        <Pagination>
            <Pagination.Prev
                disabled={page === 1}
                onClick={() => onPageChange && onPageChange(page - 1)}
            />
            {items}
            <Pagination.Next
                disabled={page === totalPages}
                onClick={() => onPageChange && onPageChange(page + 1)}
            />
        </Pagination>
    );
}

export default Page;